import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash/fp';
import * as actions from 'actions/pathBuilder';
import * as selectors from 'selectors/pathBuilder';
import addModifiers from 'utils/add_modifiers';
import Tooltip from 'components/shared/Tooltip';
import classNames from 'classnames';

const PublishPathButton = ({
  canPublishPath,
  loading,
  publish,
  isCertification,
  features,
  canPublishContent,
}) => {
  const cannotPublishContent = !canPublishContent;

  return (
    <Tooltip
      text={
        (!isCertification && canPublishPath.reason) ||
        (isCertification &&
          !canPublishPath.value &&
          t(
            'certifications.certification_builder.button_publish_certification_path_disabled',
          )) ||
        (cannotPublishContent &&
          canPublishPath.value &&
          t('paths.path_builder.needs_publish_permission'))
      }
      inline
      className={classNames({
        'fz-sm lh-20': cannotPublishContent,
      })}
    >
      <button
        type="button"
        className={addModifiers('NewButton', ['yellow', 'tallAndWide'])}
        onClick={!loading ? publish : null}
        disabled={!canPublishPath.value || cannotPublishContent}
      >
        {loading && <span className="Spinner mr-4" />}{' '}
        {!isCertification && t('paths.path_builder.button_publish_path')}
        {isCertification &&
          t(
            'certifications.certification_builder.button_publish_certification',
          )}
      </button>
    </Tooltip>
  );
};

const mapStateToProps = ({ pathBuilder, ...state }) => ({
  canPublishPath: selectors.canPublishPath(pathBuilder),
  loading: pathBuilder.updateInProgress,
  isCertification: !!get('certification')(pathBuilder),
  canPublishContent: state.meta.permissions.canPublishContent,
});

const mapDispatchToProps = {
  publish: actions.publishPath,
};

export default connect(mapStateToProps, mapDispatchToProps)(PublishPathButton);
